import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.6_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/paging.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/imgs/Logo-mini.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/imgs/not-found-job.png");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/i18n-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompanyFilter"] */ "/app/src/modules/components/Company/CompanyFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompanyPaging"] */ "/app/src/modules/components/Company/CompanyPaging.tsx");
